/**
 * @desc 文件下载
 */
import { OssDownloadParam } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DownloadFileParameter = OssDownloadParam

const method = 'GET'
const url = '/nexus/oss/download'

export const downloadFileApi = (
  params?: DownloadFileParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    params,
    ...config
  })
}

downloadFileApi.method = method
downloadFileApi.url = url
